import React, {useEffect, useState} from "react";
import FunctionsData from "../../Functions/FunctionsData";
import AnimalSingleForm from "./AnimalSingleForm";
import {Button} from "@mui/material";

export default function Step2({aStep, setAStep, animals, setAnimals,frmCampaign, setFrmCampaign, isSpcaEntered, setIsSpcaEntered, frmEmail, postCode , ReactGA,codeUnlock, microchipOnly}) {

    const [loadingVoucher, setLoadingVoucher] = useState(true);
    const [availableVoucherNumbers, setAvailableVoucherNumbers] = useState([]);
    const [loadingVoucherCount, setLoadingVoucherCount] = useState(true);
    const [availableVoucherCount, setAvailableVoucherCount] = useState(0);
    const [vouchersByEmail, setVouchersByEmail] = useState(999);
    const [currentAnimal, setCurrentAnimal] = useState(0);
    const [blocked, setBlocked] = useState(true);
    const [showAddButton, setShowAddButton] = useState(false);
    const [isSpca, setIsSpca] = useState(false);
    const [btnEnabled,setButtonEnabled] = useState(true);

    useEffect(() => {
        setIsSpca(frmEmail.toLowerCase().includes('@spca.nz') || frmEmail.toLowerCase().includes('@datasourcery.com'));
    }, [frmEmail])

    useEffect(() => {
        FunctionsData.fetchDataGet(
            '/api/voucher/by_postcode_count/' + postCode,
            setAvailableVoucherCount,
            loadingVoucherCount,
            setLoadingVoucherCount
        )
    },[loadingVoucherCount])

    useEffect(() => {
        FunctionsData.fetchDataGet(
            '/api/voucher/by_postcode/' + postCode,
            setAvailableVoucherNumbers,
            loadingVoucher,
            setLoadingVoucher
        )

        FunctionsData.fetchDataGetNoLoading(
            '/api/voucher/vouchers_issued/' + frmEmail,
            setVouchersByEmail
        )

    }, [loadingVoucher]);

    useEffect(() => {
        let arr = animals;
        let show = true;
        for (let x in arr) {
            if (arr[x]['a_source'] === '' || arr[x]['a_source'] === 'gender' || arr[x]['a_age'] === '') {
                show = false;
            }
        }

        if (arr.length === 0) {
            setShowAddButton(true);
        } else {
            setShowAddButton(show);
        }

    }, [animals])

    async function removeAnimal(id, sn) {

        let arr = animals;
        let newArr = [];
        for (let x in arr) {
            if (arr[x]['id'] !== id) {
                newArr.push(arr[x]);
            }
        }

        const tkn = await FunctionsData.getCSRFToken();
        await fetch(FunctionsData.getApiUrl('/api/voucher/unblock/') + sn, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'token': sessionStorage.tkn,
                'X-CSRF-Token': tkn.csrf
            }
        })
        // .then((res) => {return res.json()})
        // .then((d) => {toast('Animal removed')});

        for (let x in newArr) {
            newArr[x]['id'] = x;
        }

        if (currentAnimal == id && newArr.length > 0) setCurrentAnimal(newArr[0]['id']);

        setAnimals(newArr);
        setLoadingVoucher(true);

        window.gtag('event', 'action', {
            category: 'User',
            action: 'Removed animal'
        });

    }

    const AnimalBlock = (props) => {
        return (
            <div>
                {animals.map((d, idx) => {
                    return (
                        <div className={"animal-block"}>
                            <AnimalSingleForm
                                rowBase={d}
                                animals={animals}
                                setAnimals={setAnimals}
                                currentAnimal={currentAnimal}
                                setCurrentAnimal={setCurrentAnimal}
                                removeAnimal={removeAnimal}
                                blocked={blocked}
                                setBlocked={setBlocked}
                                frmEmail={frmEmail}
                                microchipOnly={microchipOnly}
                            />
                        </div>
                    )
                })}
            </div>
        )
    }

    async function refreshVouchersCount() {

        const tkn = await FunctionsData.getCSRFToken();
        const path = '/api/voucher/by_postcode_count/' + postCode;
        return await fetch(FunctionsData.getApiUrl(path), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'token': FunctionsData.getSessionToken(),
                'X-CSRF-Token': tkn.csrf
            }
        })
            .then((res) => res.json())
            .then((d) => {
                //console.log(path, d);
                return d.data;
            });
    }

    async function refreshVouchers() {

        const tkn = await FunctionsData.getCSRFToken();
        const path = '/api/voucher/by_postcode/' + postCode;
        return await fetch(FunctionsData.getApiUrl(path), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'token': FunctionsData.getSessionToken(),
                'X-CSRF-Token': tkn.csrf
            }
        })
            .then((res) => res.json())
            .then((d) => {
                //console.log(path, d);
                return d.data;
            });
    }

    async function addAnimal() {

        const l = animals.length;
        const refreshedVouchers = await refreshVouchers();
        const refreshedVouchersCount = await refreshVouchersCount();
        setAvailableVoucherCount(refreshedVouchersCount);
        setAvailableVoucherNumbers(refreshedVouchers);

        if (refreshedVouchers.length > 0 && refreshedVouchersCount > 0) {

            const voucher = refreshedVouchers[0];

            // const existingVouchers = availableVoucherNumbers.filter(({id}) => id !== voucher.id);
            // setAvailableVoucherNumbers([...existingVouchers]);

            setFrmCampaign(voucher.campaign_id);
            await FunctionsData.postData(
                '/api/voucher/block/' + voucher.id,
                {
                    blocked_at: "current_timestamp()"
                }
            )

            setAvailableVoucherCount(await refreshVouchersCount());

            await fetch(FunctionsData.getApiUrl('/api/media/barcode/') + voucher.id,
                {
                    method: 'GET',
                    headers: {'Content-Type': 'application/json', 'token': sessionStorage.tkn}
                }
            ).then(r => {
            });

            // console.log('convertUTCToLocalTime',convertUTCToLocalTime(voucher.expiry_date));

            const a = {
                name: null,
                gender: "",
                animal_type: "Cat",
                id: (l + 1),
                voucher: voucher.id,
                voucher_id: voucher.rowid,
                campaign_id: voucher.campaign_id,
                expiry_date: voucher.expiry_date,
                is_microchipped: false,
                is_pregnant: false,
                was_pregnant: false,
                a_is_owner: false,
                a_is_stray: false,
                a_part_colony: false,
                a_age: '',
                a_color_primary: '',
                a_color_secondary: '',
                a_source: '',
                a_microchip_only_flag: microchipOnly ? true : false,

            }

            let newArr = animals;
            newArr.push(a);

            setAnimals(newArr);
            setCurrentAnimal(l + 1);

            window.gtag('event', 'action', {
                category: 'User',
                action: 'Added new animal'
            });

        }

    }

    return (
        <div>
            <div className={"form"} style={{textAlign: 'left'}}>

                <h3 style={{marginBottom: 20}}>Please enter the details of every animal you would like to book in for
                    Snip'n'Chip.&nbsp;
                    {
                        (availableVoucherCount < 25 && availableVoucherCount > 0) ?
                            <>
                                This campaign is almost sold out. There are only {availableVoucherCount} vouchers available. Please email <a href={"mailto:snipnchip@spca.nz"} target={"_blank"} rel="noopener">snipnchip@spca.nz</a> if you require further assistance.
                            </>
                            : undefined
                    }
                </h3>

                <AnimalBlock animals={animals} setAnimals={setAnimals} frmEmail={frmEmail} availableVoucherCount={availableVoucherCount}/>

                <ShowAddButton {...{ animals,setIsSpcaEntered,codeUnlock,availableVoucherNumbers,vouchersByEmail,setButtonEnabled,addAnimal,isSpca,isSpcaEntered,availableVoucherCount,blocked,showAddButton,btnEnabled}}
                               availableVoucherCount={availableVoucherCount}
                               blocked={blocked}
                               showAddButton={showAddButton}
                               vouchersByEmail={vouchersByEmail}
                               addAnimal={addAnimal}
                               isSpca={isSpca}
                               btnEnabled={btnEnabled}
                               setButtonEnabled={setButtonEnabled}
                               availableVoucherNumbers={availableVoucherNumbers}
                />

                <Button
                    onClick={() => setAStep(aStep + 1)}
                    sx={{marginTop: '20px', width: '100%'}} variant={"contained"}
                    disabled={
                        (
                            animals.length === 0 || (blocked === true)
                        )
                    }
                >
                    Next: Finalise your voucher order
                </Button>

            </div>

            <Button size="full" variant={""}
                    onClick={() => setAStep(aStep - 1)}
                    sx={{margin: 1}}>Back
            </Button>
        </div>
    )
}

const ShowAddButton = ({
                           animals,setIsSpcaEntered,codeUnlock,availableVoucherNumbers,vouchersByEmail,setButtonEnabled,
                           addAnimal,isSpca,isSpcaEntered,availableVoucherCount,blocked,showAddButton,btnEnabled
}) => {

    console.log('availableVoucherNumbers',availableVoucherNumbers);
    let availableVouchers = availableVoucherNumbers.length - vouchersByEmail.issued - animals.length;

    function getNewAnimal(e) {
        setButtonEnabled(false);
        addAnimal().then(() => {
            setTimeout(() => {
                setButtonEnabled(true);
            }, 3000);
        });
    }

    if (availableVoucherNumbers.length === 0) return (
        <>
            This campaign has now sold out. Please email <a href={"mailto:snipnchip@spca.nz"} target={"_blank"}>snipnchip@spca.nz</a> and our Desexing Team will be able to provide other options for you.
        </>
    )
    if (availableVouchers < 1 && (!(isSpca === true && isSpcaEntered === true))) return (
        <>
            <ShowFormEnablePlus10 {...{setIsSpcaEntered,availableVoucherCount,codeUnlock,isSpca,showAddButton,blocked}} />
        </>
    )

    if ((isSpca === true && isSpcaEntered === true)) return (
        <div>
            <Button size="small"
                    onClick={getNewAnimal}
                    sx={{margin: 0, marginTop: 1, background: '#12C7B9'}} variant={"contained"}
            >
                {
                    (animals.length > 0) ?
                        "Add another animal (SPCA unlimited vouchers)" : "Add your animal (SPCA unlimited vouchers)"
                }
            </Button>
        </div>
    )

    return (
        <div>
            <Button size="small"
                    onClick={getNewAnimal}
                    style={{margin: 0, marginTop: 1, background: '#12C7B9'}} variant={"contained"}
                    disabled={!btnEnabled || !(availableVouchers > 0) || (blocked === true && showAddButton === false) || (availableVoucherCount ===0)}
            >
                {
                    (animals.length > 0) ?
                        "Add another animal (" + availableVouchers + " available)" :
                        "Add your animal (" + availableVouchers + " available)"
                }
            </Button>
        </div>

    )
}

const ShowFormEnablePlus10 = ({setIsSpcaEntered,availableVoucherCount,codeUnlock,isSpca,showAddButton,blocked}) => {

    const [val, setVal] = useState((setIsSpcaEntered === true) ? codeUnlock : '');

    useEffect(() => {
        setIsSpcaEntered(val === codeUnlock);
    }, [val])

    if (availableVoucherCount === 0) return (
        <div>
            It appears there are no more vouchers available for Snip'n'Chip at this point in time. If you need further assistance, please email <a
            href='mailto:snipnchip@spca.nz'>snipnchip@spca.nz</a> and we can provide some other options that may
            help you with desexing your animal/s.
        </div>
    )

    if (isSpca === false) return (
        <div>
            It appears you have already registered a maximum of 10 animals and have reached the limit for
            Snip'n'Chip. If you need further assistance, please email <a
            href='mailto:snipnchip@spca.nz'>snipnchip@spca.nz</a> and we can provide some other options that may
            help you with desexing your animal/s.
        </div>
    )

    return (
        <div style={{
            opacity: (blocked === true && showAddButton === false) ? 0.3 : 1,
            pointerEvents: (blocked === true && showAddButton === false) ? 'none' : 'all',
        }}>
            <div>It appears you have already registered a maximum of 10 animals and have reached the limit for
                Snip'n'Chip. If you need further assistance, please email <a
                    href='mailto:snipnchip@spca.nz'>snipnchip@spca.nz</a> and we can provide some other options
                that may help you with desexing your animal/s.
            </div>
            <div>
                <input value={val} className={"form-control"} style={{margin: '20px 0', width: '350px'}}
                       placeholder={"Enter code..."} onChange={(e) => {
                    setVal(e.currentTarget.value.trim().toLowerCase());
                }
                }/>
            </div>
        </div>
    )
}
